const routes = [
  {
    path: "/auth",
    component: () => import("@/layouts/auth"),
    name: "auth-layout",
    children: [
      {
        path: "sign-in",
        component: () => import("@/pages/auth/sign-in"),
      },
    ],
  },
  {
    path: "/cabinet",
    component: () => import("@/layouts/default"),
    name: "default-layout",
    children: [
      {
        path: "admin",
        name: "cabinet-admin",
        children: [
          {
            path: "home",
            component: () => import("@/pages/cabinet/admin"),
            name: "cabinet-admin-home",
          },
          {
            path: "users",
            component: () => import("@/pages/cabinet/admin/users"),
            name: "cabinet-admin-users",
            meta: { role: "CLIENT", section: "users" },
          },
          {
            path: "users/create",
            component: () => import("@/pages/cabinet/admin/users/Create"),
            name: "cabinet-admin-users-create",
            meta: { role: "CLIENT", section: "users" },
          },
          {
            path: "users/review/:id",
            component: () =>
              import("@/pages/cabinet/admin/users/review/[id].vue"),
            name: "cabinet-admin-users-review",
            meta: { role: "CLIENT", section: "users" },
          },
          {
            path: "users/update/:id",
            component: () => import("@/pages/cabinet/admin/users/update/[id]"),
            name: "cabinet-admin-users-update",
            meta: { role: "CLIENT", section: "users" },
          },
          {
            path: "admins",
            component: () => import("@/pages/cabinet/admin/users"),
            name: "cabinet-admin-admins",
            meta: { role: "ADMIN", section: "admins" },
          },
          {
            path: "admins/create",
            component: () => import("@/pages/cabinet/admin/users/Create"),
            name: "cabinet-admin-admins-create",
            meta: { role: "ADMIN", section: "admins" },
          },
          {
            path: "admins/update/:id",
            component: () => import("@/pages/cabinet/admin/users/update/[id]"),
            name: "cabinet-admin-admins-update",
            meta: { role: "ADMIN", section: "admins" },
          },
          {
            path: "tests",
            component: () => import("@/pages/cabinet/admin/tests"),
            name: "cabinet-admin-tests",
          },
          {
            path: "tests/:id/categories",
            component: () =>
              import("@/pages/cabinet/admin/tests/id/categories"),
            name: "cabinet-admin-tests-id-categories",
            meta: {
              // backUrl: "/cabinet/admin/tests",
              goBack: true,
            },
          },
          {
            path: "tests/:id/points",
            component: () => import("@/pages/cabinet/admin/tests/id/points"),
            name: "cabinet-admin-tests-id-points",
            meta: {
              backUrl: "/cabinet/admin/tests",
            },
          },
          {
            path: "tests/:id/promocodes",
            component: () =>
              import("@/pages/cabinet/admin/tests/id/promocodes"),
            name: "cabinet-admin-tests-id-promocodes",
            meta: {
              backUrl: "/cabinet/admin/tests",
            },
          },
          {
            path: "tests/:id/access-links",
            component: () =>
              import("@/pages/cabinet/admin/tests/id/access-links"),
            name: "cabinet-admin-tests-id-access-links",
            meta: {
              backUrl: "/cabinet/admin/tests",
            },
          },
          {
            path: "tests/:id/categories/:categoryId/questions",
            component: () =>
              import("@/pages/cabinet/admin/tests/id/categories/id/questions"),
            name: "cabinet-admin-tests-id-categories-categoryId-questions",
            meta: {
              backUrl: "/cabinet/admin/tests/:id/categories",
              goBack: true,
            },
          },
          {
            path: "tests/:id/categories/:categoryId/questions/create",
            component: () =>
              import(
                "@/pages/cabinet/admin/tests/id/categories/id/questions/Create"
              ),
            name: "cabinet-admin-tests-id-categories-categoryId-questions-create",
            meta: {
              backUrl:
                "/cabinet/admin/tests/:id/categories/:categoryId/questions",
            },
          },
          {
            path: "tests/:id/categories/:categoryId/reading-groups/create",
            component: () =>
              import(
                "@/pages/cabinet/admin/tests/id/categories/id/reading-groups/Create"
              ),
            name: "cabinet-admin-tests-id-categories-categoryId-reading-groups-create",
            meta: {
              backUrl:
                "/cabinet/admin/tests/:id/categories/:categoryId/questions",
            },
          },
          {
            path: "tests/:id/categories/:categoryId/reading-groups/update/:groupId",
            component: () =>
              import(
                "@/pages/cabinet/admin/tests/id/categories/id/reading-groups/update/[id]"
              ),
            name: "cabinet-admin-tests-id-categories-categoryId-reading-groups-update-groupId",
            meta: {
              backUrl:
                "/cabinet/admin/tests/:id/categories/:categoryId/questions",
            },
          },
          {
            path: "tests/:id/categories/:categoryId/matching-groups/create",
            component: () =>
              import(
                "@/pages/cabinet/admin/tests/id/categories/id/matching-groups/Create"
              ),
            name: "cabinet-admin-tests-id-categories-categoryId-matching-groups-create",
            meta: {
              backUrl:
                "/cabinet/admin/tests/:id/categories/:categoryId/questions",
            },
          },
          {
            path: "tests/:id/categories/:categoryId/matching-groups/update/:groupId",
            component: () =>
              import(
                "@/pages/cabinet/admin/tests/id/categories/id/matching-groups/update/[id]"
              ),
            name: "cabinet-admin-tests-id-categories-categoryId-matching-groups-update-groupId",
            meta: {
              backUrl:
                "/cabinet/admin/tests/:id/categories/:categoryId/questions",
            },
          },
          {
            path: "tests/:id/categories/:categoryId/questions/update/:questionId",
            component: () =>
              import(
                "@/pages/cabinet/admin/tests/id/categories/id/questions/update/[id]"
              ),
            name: "cabinet-admin-tests-id-categories-categoryId-questions-update-questionId",
            meta: {
              // backUrl: '/cabinet/admin/tests/:id/categories/:categoryId/questions',
              goBack: true,
            },
          },
          {
            path: "tests/:id/steps",
            component: () => import("@/pages/cabinet/admin/tests/id/steps"),
            name: "cabinet-admin-tests-id-steps",
            meta: {
              backUrl: "/cabinet/admin/tests",
            },
          },
          {
            path: "site-data",
            component: () => import("@/pages/cabinet/admin/site-data"),
            name: "cabinet-admin-site-data",
          },
          {
            path: "faq",
            component: () => import("@/pages/cabinet/admin/faq"),
            name: "cabinet-admin-site-faq",
          },
          {
            path: "flashcard-deck",
            component: () => import("@/pages/cabinet/admin/flashcard-deck"),
            name: "cabinet-admin-flashcard-deck",
          },
          {
            path: "daily-goals",
            component: () => import("@/pages/cabinet/admin/daily-goals"),
            name: "cabinet-admin-daily-goals",
          },
          {
            path: "flashcard-deck/:id/cards",
            component: () =>
              import("@/pages/cabinet/admin/flashcard-deck/id/cards"),
            name: "cabinet-admin-flashcard-deck-id-cards",
            meta: {
              backUrl: "/cabinet/admin/flashcard-deck",
            },
          },
          {
            path: "test-point-groups",
            component: () => import("@/pages/cabinet/admin/test-point-groups"),
            name: "cabinet-admin-test-point-groups",
          },
          {
            path: "test-point-groups/:id/points",
            component: () =>
              import("@/pages/cabinet/admin/test-point-groups/id/points"),
            name: "cabinet-admin-test-point-groups-id-points",
            meta: {
              backUrl: "/cabinet/admin/test-point-groups",
            },
          },
          {
            path: "test-modules",
            component: () => import("@/pages/cabinet/admin/test-modules"),
            name: "cabinet-admin-test-modules",
          },
          {
            path: "transactions",
            component: () => import("@/pages/cabinet/admin/transactions"),
            name: "cabinet-admin-transactions",
          },
          {
            path: "plans",
            component: () => import("@/pages/cabinet/admin/plans"),
            name: "cabinet-admin-plans",
          },
          {
            path: "plans/:id",
            component: () => import("@/pages/cabinet/admin/plans/id"),
            name: "cabinet-admin-plans-id",
            meta: {
              backUrl: "/cabinet/admin/plans",
            },
          },
          {
            path: "mcp-tokens",
            component: () => import("@/pages/cabinet/admin/mcp-tokens"),
            name: "cabinet-admin-mcp-tokens",
          },
          {
            path: "mcp-tokens/logs",
            component: () =>
              import("@/pages/cabinet/admin/mcp-tokens/logs.vue"),
            name: "cabinet-admin-mcp-tokens-logs",
            meta: {
              backUrl: "/cabinet/admin/mcp-tokens",
            },
          },
          {
            path: "attestation",
            component: () =>
              import("@/pages/cabinet/admin/test-group/modules.vue"),
            name: "cabinet-admin-attestation",
            meta: {
              group: "ATTESTATION",
              groupTitle: "Attestatsiya",
              basePath: "/cabinet/admin/attestation",
            },
          },
          {
            path: "attestation/modules/:moduleId/groups",
            component: () =>
              import("@/pages/cabinet/admin/test-group/groups.vue"),
            name: "cabinet-admin-attestation-module-groups",
            meta: {
              group: "ATTESTATION",
              groupTitle: "Attestatsiya",
              basePath: "/cabinet/admin/attestation",
              backUrl: "/cabinet/admin/attestation",
            },
          },
          {
            path: "attestation/modules/:moduleId/access-groups",
            component: () =>
              import("@/pages/cabinet/admin/test-group/access-groups.vue"),
            name: "cabinet-admin-attestation-module-access-groups",
            meta: {
              group: "ATTESTATION",
              groupTitle: "Attestatsiya",
              basePath: "/cabinet/admin/attestation",
              backUrl: "/cabinet/admin/attestation",
            },
          },
          {
            path: "attestation/modules/:moduleId/tests",
            component: () =>
              import("@/pages/cabinet/admin/test-group/tests.vue"),
            name: "cabinet-admin-attestation-module-tests",
            meta: {
              group: "ATTESTATION",
              groupTitle: "Attestatsiya",
              basePath: "/cabinet/admin/attestation",
              backUrl: "/cabinet/admin/attestation",
            },
          },
          {
            path: "attestation/modules/:moduleId/groups/:groupId/access-groups",
            component: () =>
              import("@/pages/cabinet/admin/test-group/access-groups.vue"),
            name: "cabinet-admin-attestation-module-group-access-groups",
            meta: {
              group: "ATTESTATION",
              groupTitle: "Attestatsiya",
              basePath: "/cabinet/admin/attestation",
              backUrl: "/cabinet/admin/attestation",
            },
          },
          {
            path: "attestation/modules/:moduleId/groups/:groupId/tests",
            component: () =>
              import("@/pages/cabinet/admin/test-group/tests.vue"),
            name: "cabinet-admin-attestation-group-tests",
            meta: {
              group: "ATTESTATION",
              groupTitle: "Attestatsiya",
              basePath: "/cabinet/admin/attestation",
              backUrl: "/cabinet/admin/attestation",
            },
          },
          {
            path: "tkt",
            component: () =>
              import("@/pages/cabinet/admin/test-group/modules.vue"),
            name: "cabinet-admin-tkt",
            meta: {
              group: "TKT",
              groupTitle: "TKT",
              basePath: "/cabinet/admin/tkt",
            },
          },
          {
            path: "tkt/modules/:moduleId/groups",
            component: () =>
              import("@/pages/cabinet/admin/test-group/groups.vue"),
            name: "cabinet-admin-tkt-module-groups",
            meta: {
              group: "TKT",
              groupTitle: "TKT",
              basePath: "/cabinet/admin/tkt",
              backUrl: "/cabinet/admin/tkt",
            },
          },
          {
            path: "tkt/modules/:moduleId/access-groups",
            component: () =>
              import("@/pages/cabinet/admin/test-group/access-groups.vue"),
            name: "cabinet-admin-tkt-module-access-groups",
            meta: {
              group: "TKT",
              groupTitle: "TKT",
              basePath: "/cabinet/admin/tkt",
              backUrl: "/cabinet/admin/tkt",
            },
          },
          {
            path: "tkt/modules/:moduleId/tests",
            component: () =>
              import("@/pages/cabinet/admin/test-group/tests.vue"),
            name: "cabinet-admin-tkt-module-tests",
            meta: {
              group: "TKT",
              groupTitle: "TKT",
              basePath: "/cabinet/admin/tkt",
              backUrl: "/cabinet/admin/tkt",
            },
          },
          {
            path: "tkt/modules/:moduleId/groups/:groupId/access-groups",
            component: () =>
              import("@/pages/cabinet/admin/test-group/access-groups.vue"),
            name: "cabinet-admin-tkt-module-group-access-groups",
            meta: {
              group: "TKT",
              groupTitle: "TKT",
              basePath: "/cabinet/admin/tkt",
              backUrl: "/cabinet/admin/tkt",
            },
          },
          {
            path: "tkt/modules/:moduleId/groups/:groupId/tests",
            component: () =>
              import("@/pages/cabinet/admin/test-group/tests.vue"),
            name: "cabinet-admin-tkt-group-tests",
            meta: {
              group: "TKT",
              groupTitle: "TKT",
              basePath: "/cabinet/admin/tkt",
              backUrl: "/cabinet/admin/tkt",
            },
          },
          {
            path: "book-category",
            component: () => import("@/pages/cabinet/admin/book-category"),
            name: "cabinet-admin-book-category",
          },
          {
            path: "books",
            component: () => import("@/pages/cabinet/admin/books"),
            name: "cabinet-admin-books",
          },
          {
            path: "books/:id/units",
            component: () => import("@/pages/cabinet/admin/books/id/units"),
            name: "cabinet-admin-books-id-units",
            meta: {
              backUrl: "/cabinet/admin/books",
            },
          },
          {
            path: "books/:id/units/:unitId/flashcards",
            component: () =>
              import("@/pages/cabinet/admin/books/id/units/id/flashcards"),
            name: "cabinet-admin-books-id-units-id-flashcards",
            meta: {
              goBack: true,
            },
          },
          {
            path: "books/:id/units/:unitId/matchings",
            component: () =>
              import("@/pages/cabinet/admin/books/id/units/id/matchings"),
            name: "cabinet-admin-books-id-units-id-matchings",
            meta: {
              goBack: true,
            },
          },
          {
            path: "books/:id/units/:unitId/questions",
            component: () =>
              import("@/pages/cabinet/admin/books/id/units/id/questions"),
            name: "cabinet-admin-books-id-units-id-questions",
            meta: {
              goBack: true,
            },
          },
          {
            path: "courses",
            component: () => import("@/pages/cabinet/admin/courses"),
            name: "cabinet-admin-courses",
          },
          {
            path: "courses/:id/lessons",
            component: () => import("@/pages/cabinet/admin/courses/id/lessons"),
            name: "cabinet-admin-courses-id-lessons",
            meta: {
              backUrl: "/cabinet/admin/courses",
            },
          },
          {
            path: "courses/:id/stats",
            component: () => import("@/pages/cabinet/admin/courses/id/stats"),
            name: "cabinet-admin-courses-id-stats",
            meta: {
              goBack: true,
            },
          },
          {
            path: "courses/:id/lessons/:lessonId/stats",
            component: () =>
              import("@/pages/cabinet/admin/courses/id/lessons/id/stats"),
            name: "cabinet-admin-courses-id-lessons-id-stats",
            meta: {
              goBack: true,
            },
          },
          {
            path: "courses/:id/lessons/:lessonId/files",
            component: () =>
              import("@/pages/cabinet/admin/courses/id/lessons/id/files"),
            name: "cabinet-admin-courses-id-lessons-id-files",
            meta: {
              goBack: true,
            },
          },
          {
            path: "courses/:id/lessons/:lessonId/videos",
            component: () =>
              import("@/pages/cabinet/admin/courses/id/lessons/id/videos"),
            name: "cabinet-admin-courses-id-lessons-id-videos",
            meta: {
              goBack: true,
            },
          },
          {
            path: "courses/:id/lessons/:lessonId/exercises",
            component: () =>
              import("@/pages/cabinet/admin/courses/id/lessons/id/exercises"),
            name: "cabinet-admin-courses-id-lessons-id-exercises",
            meta: {
              goBack: true,
            },
          },
          {
            path: "courses/:id/lessons/:lessonId/exercises/:exerciseId/flashcards",
            component: () =>
              import(
                "@/pages/cabinet/admin/courses/id/lessons/id/exercises/id/flashcards"
              ),
            name: "cabinet-admin-courses-exercise-flashcards",
            meta: {
              goBack: true,
            },
          },
          {
            path: "courses/:id/lessons/:lessonId/exercises/:exerciseId/matchings",
            component: () =>
              import(
                "@/pages/cabinet/admin/courses/id/lessons/id/exercises/id/matchings"
              ),
            name: "cabinet-admin-courses-exercise-matchings",
            meta: {
              goBack: true,
            },
          },
          {
            path: "courses/:id/lessons/:lessonId/exercises/:exerciseId/questions",
            component: () =>
              import(
                "@/pages/cabinet/admin/courses/id/lessons/id/exercises/id/questions"
              ),
            name: "cabinet-admin-courses-exercise-questions",
            meta: {
              goBack: true,
            },
          },
          {
            path: "courses/:id/lessons/:lessonId/exercises/:exerciseId/questions/create",
            component: () =>
              import(
                "@/pages/cabinet/admin/courses/id/lessons/id/exercises/id/questions/Create"
              ),
            name: "cabinet-admin-courses-exercise-question-create",
            meta: {
              goBack: true,
            },
          },
          {
            path: "courses/:id/lessons/:lessonId/exercises/:exerciseId/questions/update/:questionId",
            component: () =>
              import(
                "@/pages/cabinet/admin/courses/id/lessons/id/exercises/id/questions/update/[id]"
              ),
            name: "cabinet-admin-courses-exercise-question-update",
            meta: {
              goBack: true,
            },
          },
          {
            path: "courses/:id/lessons/:lessonId/exercises/:exerciseId/fields",
            component: () =>
              import(
                "@/pages/cabinet/admin/courses/id/lessons/id/exercises/id/fields"
              ),
            name: "cabinet-admin-courses-exercise-fields",
            meta: {
              goBack: true,
            },
          },
          {
            path: "course-groups",
            component: () => import("@/pages/cabinet/admin/course-groups"),
            name: "cabinet-admin-course-groups",
          },
          {
            path: "course-groups/:id/students",
            component: () =>
              import("@/pages/cabinet/admin/course-groups/id/students"),
            name: "cabinet-admin-course-groups-id-students",
            meta: {
              backUrl: "/cabinet/admin/course-groups",
            },
          },
          {
            path: "course-groups/:id/invites",
            component: () =>
              import("@/pages/cabinet/admin/course-groups/id/invites"),
            name: "cabinet-admin-course-groups-id-invites",
            meta: {
              backUrl: "/cabinet/admin/course-groups",
            },
          },
          {
            path: "module-access-groups",
            component: () =>
              import("@/pages/cabinet/admin/module-access-groups"),
            name: "cabinet-admin-module-access-groups",
          },
          {
            path: "module-access-groups/:id/users",
            component: () =>
              import("@/pages/cabinet/admin/module-access-groups/id/users"),
            name: "cabinet-admin-module-access-groups-id-users",
            meta: {
              backUrl: "/cabinet/admin/module-access-groups",
            },
          },
          {
            path: "module-access-groups/:id/progress",
            component: () =>
              import("@/pages/cabinet/admin/module-access-groups/id/progress"),
            name: "cabinet-admin-module-access-groups-id-progress",
            meta: {
              backUrl: "/cabinet/admin/module-access-groups",
            },
          },
          {
            path: "module-access-groups/:id/invites",
            component: () =>
              import("@/pages/cabinet/admin/module-access-groups/id/invites"),
            name: "cabinet-admin-module-access-groups-id-invites",
            meta: {
              backUrl: "/cabinet/admin/module-access-groups",
            },
          },
          {
            path: "media",
            component: () => import("@/pages/cabinet/admin/media"),
            name: "cabinet-admin-media",
          },
          {
            path: "media/:id",
            component: () => import("@/pages/cabinet/admin/media"),
            name: "cabinet-admin-media-folder",
          },
          {
            path: "statistics",
            component: () => import("@/pages/cabinet/admin/statistics"),
            name: "cabinet-admin-site-statistics",
          },
          {
            path: "activity",
            component: () => import("@/pages/cabinet/admin/activity"),
            name: "cabinet-admin-activity",
          },
          {
            path: "partners",
            component: () => import("@/pages/cabinet/admin/partners"),
            name: "cabinet-admin-partners",
          },
          {
            path: "student-results",
            component: () => import("@/pages/cabinet/admin/student-results"),
            name: "cabinet-admin-student-results",
          },
        ],
      },
    ],
  },

  {
    path: "/user",
    component: () => import("@/layouts/user"),
    name: "user-layout",
    children: [
      {
        path: "profile",
        component: () => import("@/pages/user/profile"),
        name: "user-profile",
      },
      {
        path: "test/:token",
        component: () => import("@/pages/user/test/[token]"),
        name: "user-test-token",
      },
    ],
  },

  {
    path: "/site/test/:token",
    component: () => import("@/pages/site/test/[token]"),
    name: "site-test-token",
  },

  {
    path: "/site/tg-test/:uid",
    component: () => import("@/pages/site/tg-test/[uid]"),
    name: "site-tg-test-uid",
  },

  {
    path: "/user/auth",
    component: () => import("@/pages/user/auth"),
    name: "user-auth",
  },
];

export default routes;
